import { Component } from 'react';
import List from "@mui/material/List";
import HRFormListDetail from "./HRFormListDetail";
import { getFiltersInstance, getMyFormsAndInterviews } from "../../redux/humanResources/humanResourcesActions";
import { connect } from 'react-redux';
import FormsFilters from './FormsFilters';

class MyFormsTab extends Component {

    constructor(props) {
        super(props);

        props.getMyFormsAndInterviews(this.props.activeUser, this.props.formsFilters[getFiltersInstance(true, false, false)]);
    }

    render() {
        let details = [];

        this.props.interviews.forEach((i) => {
            details.push(
                <HRFormListDetail
                    globalContainer={this.props.globalStore.container}
                    className="form-list-detail"
                    key={i.id}
                    interview={i}
                    myFormsTab
                />
            );
        });

        return (
            <div className="container-with-footer">
                <FormsFilters interviews={this.props.interviews} myFormsTab />
                <List className="row">{details.map((d) => d)}</List>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        interviews: state.forms.myInterviews,
        formsFilters: state.forms.formsFilters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMyFormsAndInterviews: (user, formsFilters) => dispatch(getMyFormsAndInterviews(user, formsFilters)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyFormsTab);
